import { FULL_SITE_MAP } from '../types';

const initialState = {
  defaultFaqValue: null,
  defaultNotificationValue: null,

  // 
  isLoading: true,
  value: '',
  menus: [],
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  report: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  introduction: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
};

const mapReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SITE_MAP.Faq: {
      return {
        ...state,
        defaultFaqValue: action.payload
      };
    }
    case FULL_SITE_MAP.Notification: {
      return {
        ...state,
        defaultNotificationValue: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default mapReducer;
